import { render } from "./LevelSpecial.vue?vue&type=template&id=11a2d5ad&scoped=true&ts=true"
import script from "./LevelSpecial.vue?vue&type=script&lang=ts"
export * from "./LevelSpecial.vue?vue&type=script&lang=ts"

import "./LevelSpecial.vue?vue&type=style&index=0&id=11a2d5ad&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a2d5ad"]])

export default __exports__